import { FormGroup } from '@angular/forms';
import { getControl, getGroup } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';

export const getCoopTrasportoGroup = (form: FormGroup): FormGroup => getGroup(form, formPaths.schedaCoopTrasporto);

export const getCoopTrasportoControl = (form: FormGroup, path: string) => getControl(form, `${formPaths.schedaCoopTrasporto}.${path}`);
